import React from "react";
import { sanitizeRichText } from "@/lib/public-content";
interface RichTextDisplayProps {
  content: string | Record<string, unknown> | null | undefined;
  className?: string;
  fallbackText?: string;
}
export function RichTextDisplay({ content, className = "prose prose-sm max-w-none", fallbackText = "No description provided." }: RichTextDisplayProps) {
  const html = sanitizeRichText(content);
  if (!html.trim()) return <div className={`${className} text-muted-foreground italic`}>{fallbackText}</div>;
  return <div className={`${className} [&_p]:leading-7 [&_table]:w-full [&_th]:border [&_th]:p-2 [&_td]:border [&_td]:p-2`} dangerouslySetInnerHTML={{ __html: html }} />;
}
